import styled from 'styled-components';
import SwapIconSvg from './swap.svg';

const SwapIcon = styled(SwapIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || '#647a97'};
  transform: rotate(90deg);
`;

export default SwapIcon;

